import {Component, Vue} from "vue-property-decorator";
import HeaderContainer from "@/components/HeaderContainer.vue";
import ReservationCard from "@/components/ReservationCard.vue";
import CalendarFilter from "@/components/CalendarFilter.vue";
import SeparationTitle from "@/components/SeparationTitle.vue";
import BubbleAction from "@/components/BubbleAction.vue";
import {ReservationCardConfig, CardStatus} from "@/types/ReservationCardConfig";
import api from "@/services/apiService";
import moment from "moment";
import 'moment/locale/fr';
import {ReservationAPIGlobalInterface, ReservationAPIInterface} from "@/entity/Reservation";
import {UserAPIInterface} from "@/entity/User";
import {ErrorService} from "@/services/ErrorService";


@Component({
  components: {
    HeaderContainer,
    ReservationCard,
    CalendarFilter,
    SeparationTitle,
    BubbleAction,
  },
})

export default class ReservationList extends Vue {
  public currentTab: 'a venir' | 'anciennes' = 'a venir';
  public allReservations: ReservationCardConfig[] = [];
  public allFilteredReservations: ReservationCardConfig[] = [];
  public datePickerIsVisible: boolean = false;
  public searchInputIsVisible: boolean = false
  public chosenDateToFilter: string = "";
  public totalItems: number = 0;
  public termToSearch: string = "";
  public isLoadingReservations: boolean = true;
  public showScrollTrigger: boolean = true;
  public searchTimeout: number = 0;
  public blockTabChangeClick: boolean = false;

  public monthToDisplay = "";
  public moisAffiche = "";
  public jourAffiche = "";
  public pageToRequest = 1;
  public isMonthAlreadyDisplayed: boolean = false;
  public activeFilter = "";
  public dayDisplayed = {
    isDayDisplayed: false as boolean,
    monthDayDisplayed: "",
    yearDayDisplayed: "",
    oldOrNew: ""
  };
  public configurationCardIsLoading = {
    path: "",
    class: CardStatus.Loading,
    day: {
      withDay: true,
      number: "",
      text: "",
      isCurrentDay: true,
    },
    name: "",
    hours: {
      start: "",
      end: "",
    },
    owner: "",
  };
  public configurationTitleIsLoading = {
    text: "Chargement en cours ...",
    isMonthDisplayed: true
  };

  get reservationDate(): string[] {
    let reservationsDates: string[] = [];
    for (let reservation of this.allReservations) {
      let dateInText = reservation.card.day.number + " " + reservation.title.text;
      reservationsDates.push(dateInText);
    }
    return reservationsDates;
  }

  get configureNotMainTitles() {
    return {
      text: "Aucune réservation trouvée",
      isMonthDisplayed: true
    };
  }

  async mounted() {
    moment.locale('fr');

    await this.getReservationList(1, true).then(() => this.isSeparatorToDisplay());

    if (this.totalItems === this.allReservations.length)
      this.showScrollTrigger = true;

    var observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        let isOld = "";
        if (this.currentTab === "a venir") {
          isOld = "add";
        } else {
          isOld = "subtract";
        }
        this.getMoreReservations(isOld, true).then(() => {
          this.isSeparatorToDisplay();
        });
      }
    }, {threshold: [0]});
    observer.observe(<Element>document.querySelector("#triggerToLoad"));
  }

  public isSeparatorToDisplay(): void {
    this.moisAffiche = "";
    for (let reservation of this.allFilteredReservations) {
      let moisAnnee = reservation.title.text;
      this.monthToDisplay = moisAnnee;

      reservation.title.isMonthDisplayed = false;
      let stringDate = reservation.card.day.number + " " + reservation.title.text;
      let date = moment(stringDate, "DD MMMM YYYY").toDate()

      if (!this.isMonthAlreadyDisplayed) {
        reservation.title.isMonthDisplayed = true;
        this.isMonthAlreadyDisplayed = true;
        this.moisAffiche = moisAnnee;
      } else {
        if (this.moisAffiche !== moisAnnee) {
          reservation.title.isMonthDisplayed = true;
          this.isMonthAlreadyDisplayed = true;
          this.moisAffiche = moisAnnee;
        } else {
          reservation.title.isMonthDisplayed = false;
        }
      }
      this.moisAffiche = moisAnnee;
    }
  }

  public checkIsWithDay(reservation: ReservationAPIInterface): boolean {
    let startDate = moment(reservation.startDate);
    if (!this.dayDisplayed.isDayDisplayed ||
      this.jourAffiche !== startDate.format('D') ||
      (this.dayDisplayed.isDayDisplayed && startDate.format("MMMM") !== this.dayDisplayed.monthDayDisplayed) ||
      (this.dayDisplayed.isDayDisplayed && startDate.format("YYYY") !== this.dayDisplayed.yearDayDisplayed)) {
      this.dayDisplayed.isDayDisplayed = true;
      this.dayDisplayed.monthDayDisplayed = startDate.format('MMMM');
      this.dayDisplayed.yearDayDisplayed = startDate.format('YYYY');
      this.jourAffiche = startDate.format('D')
      return true;
    } else {
      return false;
    }
  }

  public checkIsToday(date: any): boolean {
    return moment(date).format('l') === moment(new Date()).format('l');
  }

  public filterReservationsByChosenDate() {
    let chosenDateDayNumber = moment(this.chosenDateToFilter).format('D');
    let chosenDateMonthAndYear = moment(this.chosenDateToFilter).format('MMMM YYYY');
    this.activeFilter = chosenDateDayNumber + " " + chosenDateMonthAndYear;
    this.allFilteredReservations = this.allReservations.filter(function (el) {
      return el.card.day.number === chosenDateDayNumber && el.title.text === chosenDateMonthAndYear;
    });
  }

  public resetFilter() {
    this.allFilteredReservations = this.allReservations;
    this.isSeparatorToDisplay();
    this.activeFilter = "";
    this.termToSearch = "";
    if (this.allReservations.length !== this.totalItems)
      this.isLoadingReservations = true;
  }

  public toggleDatePicker() {
    if (this.termToSearch !== "") {
      this.resetFilter();
    }
    this.moisAffiche = "";
    this.datePickerIsVisible = !this.datePickerIsVisible;
    this.isSeparatorToDisplay();
    this.searchInputIsVisible = false;
  }

  public toggleSearchInput() {
    setTimeout(() => {
      const searchInput = this.$refs.search as HTMLInputElement
      searchInput.focus();
    }, 0);
    if (!this.searchInputIsVisible && this.termToSearch !== "") {
      this.resetFilter();
    } else if (this.chosenDateToFilter !== "" && this.activeFilter !== "") {
      this.chosenDateToFilter = "";
      this.resetFilter();
    }
    this.searchInputIsVisible = !this.searchInputIsVisible;
    this.datePickerIsVisible = false;
  }

  async search() {
    if (this.termToSearch === "")
      return;
    let request: string;
    this.isLoadingReservations = true;
    this.activeFilter = this.termToSearch;
    this.allFilteredReservations = [];
    this.showScrollTrigger = false;

    if (this.currentTab === "a venir") {
      request = 'reservations?name=' + this.termToSearch + '&startDate[after]=' + moment().format("MM/DD/YYYY HH:mm") + '&status[]=1&page=1&itemsPerPage=60&order[startDate]=asc';
    } else {
      request = 'reservations?name=' + this.termToSearch + '&startDate[before]=' + moment().format("MM/DD/YYYY HH:mm") + '&status[]=1&page=1&itemsPerPage=60&order[startDate]=desc';
    }

    try {
      this.isLoadingReservations = true;
      const response: ReservationAPIGlobalInterface = await api.authRequest.get(request);
      this.pushReservations(response, true);
      this.isLoadingReservations = false;
      this.isSeparatorToDisplay();
    } catch (error) {
      this.isLoadingReservations = false;
      ErrorService.dealWithTheError(error);
    }
    this.showScrollTrigger = true;
  }

  public autocomplete() {
    clearTimeout(this.searchTimeout);
    if (this.termToSearch.length < 2) {
      return;
    }
    this.searchTimeout = setTimeout(() => {
      this.search();
    }, 500);
  }

  public changeTabActions(newTab: 'a venir' | 'anciennes') {
    if (newTab !== this.currentTab && !this.blockTabChangeClick) {
      this.allReservations = [];
      this.blockTabChangeClick = !this.blockTabChangeClick;
      this.currentTab = newTab;
      this.totalItems = 0;
      this.pageToRequest = 1;
      this.chosenDateToFilter = "";
      this.resetFilter();
      this.getReservationList()
        .then(() => {
          this.isSeparatorToDisplay();
        })
        .finally(() => {
        this.blockTabChangeClick = !this.blockTabChangeClick;
      });
    }
  }

  public onDateClose(newDate: Date | null) {
    this.isLoadingReservations = false;
    this.moisAffiche = "";
    if (newDate !== null) {
      this.chosenDateToFilter = moment(newDate).format('YYYY-MM-DD');
    }
    this.filterReservationsByChosenDate();
    this.isSeparatorToDisplay();
  }

  async getMoreReservations(addOrSubtract: string, isFromScroll: boolean = false) {
    if (this.allReservations[this.allReservations.length - 1]) {
      let momentTimeOfLastReservationInArray = moment(this.allReservations[this.allReservations.length - 1].card.day.number + " " + this.allReservations[this.allReservations.length - 1].title.text, "DD MMMM YYYY");
      this.pageToRequest++;

      if (this.currentTab !== "a venir" && addOrSubtract !== "add") {
        if (this.allReservations.length < this.totalItems) {
          await this.getReservationList(this.pageToRequest, false);
          if (!isFromScroll) {
            // @ts-ignore
            if (momentTimeOfLastReservationInArray.toDate() > moment(this.$refs["calendar-filter"]['currentMonth'], "MMMM YYYY").subtract(1, "months").endOf("month").toDate()) {
              await this.getMoreReservations('substract');
            }
          }
        }
      } else if (addOrSubtract === "add") {
        if (this.allReservations.length < this.totalItems) {
          await this.getReservationList(this.pageToRequest, false);
          if (!isFromScroll) {
            // @ts-ignore
            if (momentTimeOfLastReservationInArray.toDate() < moment(this.$refs["calendar-filter"]['currentMonth'], "MMMM YYYY").add(1, "months").endOf("month").toDate()) {
              await this.getMoreReservations("add");
            }
          }
        }
      }
    }
  }

  async getReservationList(pageToRequest: number = 1, isFirstRequest: boolean = true) {

    let request = "reservations";
    if (this.currentTab === 'a venir') {
      request += '?startDate[after]=' + moment().format("MM/DD/YYYY HH:mm") + '&status[]=1&page=' + pageToRequest + '&itemsPerPage=60&order[startDate]=asc';
    } else {
      request += '?startDate[before]=' + moment().format("MM/DD/YYYY HH:mm") + '&status[]=1&page=' + pageToRequest + '&itemsPerPage=60&order[startDate]=desc';
    }

    if (isFirstRequest) {
      this.allFilteredReservations = [];
    }

    try {
      if (this.activeFilter === "")
        this.isLoadingReservations = true;
      const response: ReservationAPIGlobalInterface = await api.authRequest.get(request);
      this.pushReservations(response);
      this.totalItems = response['hydra:totalItems'];
      if (this.allReservations.length === this.totalItems) this.isLoadingReservations = false;
    } catch (error) {
      this.isLoadingReservations = false;
      ErrorService.dealWithTheError(error);
    }
  }

  public formatReservations(reservation: ReservationAPIInterface) {
    const startDateString = reservation.startDate.slice(0, 19);
    const startDate = moment(startDateString);
    const endDateString = reservation.endDate.slice(0, 19);
    const endDate = moment(endDateString);

    // @ts-ignore
    const owner: UserAPIInterface = reservation.owner;

    const classType = (owner.email === this.$store.state.authModule.user.email) ? CardStatus.Normal : CardStatus.Disabled;
    const path = (classType === CardStatus.Normal) ? '/reservation/view/' + reservation.id : '';
    const ownerText = (classType === CardStatus.Disabled) ? owner.email : 'moi';

    let reservationFormated: ReservationCardConfig = {
      card: {
        path: path,
        class: classType,
        day: {
          withDay: this.checkIsWithDay(reservation),
          number: startDate.format('D'),
          text: startDate.format('ddd'),
          isCurrentDay: this.checkIsToday(reservation.startDate),
        },
        name: reservation.name,
        hours: {
          start: startDate.format('LT'),
          end: endDate.format('LT'),
        },
        owner: ownerText,
      },
      title: {
        text: moment(reservation.startDate).format('MMMM YYYY'),
        isMonthDisplayed: true
      }
    };
    return reservationFormated;
  }

  public pushReservations(response: ReservationAPIGlobalInterface, isFromSearch: boolean = false) {
    const reservations = response['hydra:member'];
    for (const reservation of reservations) {
      let formattedReservation = this.formatReservations(reservation)
      if (!isFromSearch || this.activeFilter !== "") {
        this.allReservations.push(formattedReservation);
      }

      if (this.chosenDateToFilter === "")
        this.allFilteredReservations.push(formattedReservation);
    }
  }
}
